document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('FitGuideToggle');
  const modal = document.getElementById('FitGuideModal');
  const closeBtn = document.getElementById('FitGuideClose');

  if (!toggle || !modal) return;

  toggle.addEventListener('click', function () {
    modal.classList.add('is-active');
  });

  closeBtn.addEventListener('click', function () {
    modal.classList.remove('is-active');
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) modal.classList.remove('is-active');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') modal.classList.remove('is-active');
  });
});